<template>
  <div class="mobile-wrapper" :class="isSushi && 'montserrat-500'">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt" :style="getStyle()">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack">keyboard_arrow_left</span>
            <span :class="isSushi ? 'montserrat-700' :  'title-text'"  @click="goBack">User Stamps</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white vform position-relative">
      <div class="justify-content-center">
        <div class="col-12 bg-white py-4">
          <div class="vertical-center justify-content-center">
            <div>
              <div class="container">
                <div class="text-center">
                  <div>{{ $t('message.loyaltyStamps') }}</div>
                  <div>{{(dbuser.RewardPoints?dbuser.RewardPoints:0) | formatNumber}}</div>
                </div>
                <hr />
              </div>
              <div
                v-if="getFirstValidRedemptionRule"
                class="container mb-4 mt-4 justify-content-center"
              >
                <div class="row justify-content-center mb-4">{{getLoyalityMessage}}</div>
                <div width="300" class="row justify-content-center">
                  <canvas id="circleContainer"></canvas>
                  <div :style="shapeStyles()" class="inner-shape">
                    <i class="fa fa-heart"></i>
                  </div>
                </div>
                <div
                  class="row justify-content-center mb-0"
                  :style="getDetStyles()"
                >{{(dbuser.RewardPoints?dbuser.RewardPoints>getFirstValidRedemptionRule.Point?getFirstValidRedemptionRule.Point:dbuser.RewardPoints:0)}}/{{getFirstValidRedemptionRule.Point}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/Loyalty.js";
import common from "../../sharedscripts/Common/commonMobile";
import { interpolate } from "../../api/helpers/stringHelper";
export default {
  data() {
    return {
      page: 2,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "currentstore",
      "mobileStyles",
      "currentStoreDoc",
      "getFirstValidRedemptionRule"
    ]),
    ...shared.computed,
    getLoyalityMessage() {
      return interpolate(
        this.$t("message.collectGetFree"),
        this.getFirstValidRedemptionRule.Point,
        this.getFirstValidRedemptionRule.Name
      );
    },
    isSushi(){
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  mounted() {
    this.drawCircleMobile(this.mobileStyles.alertInfoBackGround.background);
  },
  methods: {
    ...common.methods,
    ...shared.methods
  }
};
</script>

